import React from 'react';
import {useState} from 'react'
import Story from "./Story";
import Filter from "./Filter";
import {stories, StoryType} from "../data/StoryList";
import {filtersList, FilterType} from "../data/FilterList";

export default function Stories(this: any) {
    const [filters, setFilters] = useState(filtersList);

    function checkFilters(story: StoryType) {
        let isPairing = false;
        let isComplete = false;
        let isLength = false;
        filters.forEach((filter: FilterType) => {
            if ((filter.id === story.pairingId) && filter.active) isPairing = true;
            if ((filter.id === story.completedStatus) && filter.active) isComplete = true;
            if (((filter.id === story.length)) && filter.active) isLength = true;
        })
        return isPairing && isComplete && isLength;
    }

    return (
        <section id="stories">
            <div className="stories-top">
                <h1>
                    Stories
                </h1>
            </div>
            <div className="story-content">
                <div id="stories-container" className={'u-px-1'}>
                    {stories.map((story: StoryType) => {
                        if (checkFilters(story)) {
                            return <Story key={story.id} story={story}/>
                        }
                        return '';
                    })}
                </div>

                <aside id="story-filter">
                    <Filter filters={filters} setFilters={setFilters}/>
                </aside>
            </div>
            <div className="story-footer"> </div>
        </section>
    )
}